import React, { useEffect, useState } from 'react';
import Nlayout from '../layout/Nlayout';
import { Alert, Grid, Typography } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import './galeria.css'
function Galeria(props) {
    const { usuario } = useParams();

    const [imagen, setImagen] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploadedUrl, setUploadedUrl] = useState('');
    const [cargando, setCargando] = useState(false);
    const [imgUser, setImgUser] = useState([])
    const [userInfo, setUserInfo] = useState()
    const handleChange = (e) => {
        const file = e.target.files[0];
        setImagen(file);
        setPreview(URL.createObjectURL(file));
    };


    const fetchNews = async () => {
        try {
            const response = await axios.get(`https://backmu.vercel.app/infoUser/user/${usuario}`);
            // Ordenar las noticias por la fecha de creación en orden descendente (primero la más reciente)

            setUserInfo(response.data.cashShopData)
        } catch (error) {
            console.error('Error al obtener noticias:', error);
        }
    };

    useEffect(() => {
        fetchNews()
    }, [usuario])

   
    const ObtenerImagenes = async () => {
        try {
            const response = await axios.get(`https://backmu.vercel.app/guardar-imagen/${usuario}`)

            setImgUser(response.data)
        } catch (err) {

        }
    }

    useEffect(() => {
        ObtenerImagenes()
    }, [])
console.log('userInfo?.WCoinP', userInfo?.WCoinP)
    const handleUpload = async () => {
        if (!imagen) return;
        if (userInfo?.WCoinP  < 1000 || !userInfo?.WCoinP) {
            Alert('No tenés suficientes WCoinP para subir una imagen.');
            return;
          }
        setCargando(true);

        try {
            // Subir la imagen a Cloudinary
            const formData = new FormData();
            formData.append('file', imagen);
            formData.append('upload_preset', 'ml_default');  // Usar el preset que configuraste en Cloudinary

            const cloudinaryResponse = await fetch('https://api.cloudinary.com/v1_1/dks7seyl8/upload', {
                method: 'POST',
                body: formData,
            });

            const cloudinaryData = await cloudinaryResponse.json();
            const imageUrl = cloudinaryData.secure_url; // Obtener la URL de la imagen subida

            // Enviar la URL de la imagen a backend1 (Vercel)
            const response = await axios.post('https://backmu.vercel.app/guardar-imagen', {
                userId: usuario,
                imageUrl: imageUrl,
            });
            
            if (response.data.message) {
                setUploadedUrl(imageUrl); // Establecer la URL de la imagen si la subida fue exitosa
                
            } else {
                alert('Hubo un error al guardar la URL en la base de datos');
            }
        } catch (err) {


        } finally {
            setCargando(false);
            window.location.href = "/";
            
        }
    };

    return (
        <Nlayout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded} isMobile={props.isMobile}>
            <Grid style={{ display: 'flex', flexDirection: 'column', gap: 15, marginTop: 10, padding: 15, borderRadius: 5, boxShadow: '0 2px 4px rgba(0,0,0,0.1)', width: '100%' }}>
                <Alert severity="info">Tiene un costo de 1.000 Silver Coins</Alert>
                <Typography variant="body1" style={{ fontWeight: 'bold' }}>Tus fotos</Typography>

                <Grid style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                    {
                        imgUser.map((img) => {
                            return (<img src={img?.url} style={{ width: '10%' }} />)
                        })
                    }
                </Grid>



                <input type="file" accept="image/*" onChange={handleChange} />

                {preview && (
                    <div style={{ marginTop: '1rem' }}>
                        <p>Previsualización:</p>
                        <img src={preview} alt="preview" width="200" />
                    </div>
                )}

                <button onClick={handleUpload} disabled={cargando || !imagen || !userInfo?.WCoinP || userInfo?.WCoinP < 1000}  style={{ marginTop: '1rem' }}>
                    {cargando ? 'Subiendo...' : userInfo?.WCoinP < 1000 || !userInfo?.WCoinP  ? 'No tienes suficientes Silver Coins' :  'Subir imagen'}
                </button>

                {uploadedUrl && (
                    <div style={{ marginTop: '1rem' }}>
                        <p>Imagen subida con éxito:</p>
                        <a href={uploadedUrl} target="_blank" rel="noopener noreferrer">{uploadedUrl}</a>
                        <br />
                        <img src={uploadedUrl} alt="uploaded" width="200" />
                    </div>
                )}
            </Grid>
        </Nlayout>
    );
}

export default Galeria;
